import { render, staticRenderFns } from "./Tui-ImageEditorComponent.vue?vue&type=template&id=cd7a6b84"
import script from "./Tui-ImageEditorComponent.vue?vue&type=script&lang=js"
export * from "./Tui-ImageEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports